import { Skeleton } from '@/components/ui/skeleton';

/**
 * Skeleton loading state for a single post.
 * Matches the layout of the Post component.
 */
export function PostSkeleton() {
  return (
    <div className="w-full flex flex-col text-left">
      <div className="flex flex-col gap-2">
        {/* Title row - author and timestamp */}
        <div className="flex justify-between w-full">
          <Skeleton className="h-6 w-32" />
          <div className="flex items-center gap-1">
            <Skeleton className="h-5 w-5" />
            <Skeleton className="h-4 w-20" />
          </div>
        </div>

        {/* Optional image area */}
        <Skeleton className="w-full h-48 rounded-lg" />

        {/* Content */}
        <div className="flex flex-col gap-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
          <Skeleton className="h-4 w-4/6" />
        </div>

        {/* Action Bar */}
        <div className="flex justify-between w-full mt-4">
          <div className="flex items-center gap-1">
            <Skeleton className="h-5 w-5" />
            <Skeleton className="h-4 w-8" />
          </div>
          <Skeleton className="h-5 w-5" />
        </div>
      </div>
    </div>
  );
}

